import { Stack } from '@astryxdesign/core/Stack'
import { Text } from '@astryxdesign/core/Text'
import { Link } from '@astryxdesign/core/Link'
import HeroPage from '../components/HeroPage'

// The support page: one sentence and an address.
//
// The address used to be a Bulma tag - a coloured pill that looked clickable
// and was not. It is a mailto link now, which is what a reader was trying to
// do when they clicked it. The address itself is unchanged, including the
// "at"/"dot" spelling the site uses to keep it out of scrapers; the mailto
// target spells it properly because a link has to.
export function SupportView() {
    return (
        <HeroPage
            heading="Support"
            footerLinks={false}
        >
            <Stack gap={5} hAlign="center">
                <Text as="p" justify="center">
                    Pour toute question à propos de l'application, ou des données que
                    nous utilisons, vous pouvez nous contacter à l'adresse suivante
                </Text>
                <Link href="mailto:support@padelr.app" isStandalone hasUnderline>
                    support at padelr dot app
                </Link>
                <Link href="/">Retour à l'accueil</Link>
            </Stack>
        </HeroPage>
    )
}

export default SupportView
